export const createOptions = (options = {}) => {
  const { onSuccess, ...rest } = options;

  const result = rest;

  if (typeof onSuccess === 'function') {
    result.onSuccess = (data) => {
      if (data !== 'Error') {
        onSuccess(data);
      }
    };
  }

  return result;
};
